import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/dental-implants/hero";
import WhatAndWhy from "../components/dental-implants/what-and-why";
import Process from "../components/dental-implants/process";
import AfterCare from "../components/dental-implants/aftercare";
import CTA from "../components/dental-implants/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import TransformYourSmile from "../components/dental-implants/transform-your-smile";
import QuestionsImplants from "../components/dental-implants/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Dental Implants in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "Dental Implants",
    url: "https://www.regent-dental.co.uk/dental-implants",
    description:
      "Regent Dental offers high-quality dental implants to restore missing teeth with a permanent, natural-looking solution.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Am I suitable?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Anyone who has lost a tooth or several teeth is a candidate for dental implants. A full assessment is completed and treatment is tailored to the individual’s needs using diagnostic and radiographic techniques.",
        },
      },
      {
        "@type": "Question",
        name: "I have gum disease, can I have implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, periodontal patients can have dental implants, but the gum disease must be treated beforehand. The risk of complications is higher, but with regular maintenance, implants can still be successful.",
        },
      },
      {
        "@type": "Question",
        name: "Will you have to remove or treat diseased teeth prior to treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, if teeth are beyond saving or infected, they may need to be removed before implant placement to prevent bone loss and ensure a healthy foundation for the implants.",
        },
      },
      {
        "@type": "Question",
        name: "How long do implants last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Dental implants have high success rates, with 90% lasting over 10 years. With proper care, including regular hygiene visits and daily cleaning, implants can last more than 25 years.",
        },
      },
      {
        "@type": "Question",
        name: "What is a sinus graft?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A sinus graft or sinus lift is a procedure to add bone in the upper jaw near the molars and premolars to allow implant placement in areas with low bone volume.",
        },
      },
      {
        "@type": "Question",
        name: "I’m a really nervous patient, what are my options?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We offer a relaxed environment and dental sedation, including intravenous sedation, to help anxious patients feel calm and comfortable during their treatment.",
        },
      },
      {
        "@type": "Question",
        name: "Can dental implants be done in a single day?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, some patients may be eligible for same-day dental implants. Factors like bone density, oral health, and overall health determine suitability for this procedure.",
        },
      },
      {
        "@type": "Question",
        name: "What is the difference between full arch implants and traditional dentures?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Full arch implants are fixed to the jawbone and do not move, unlike dentures. They feel more natural, require no adhesives, and help prevent jawbone loss.",
        },
      },
      {
        "@type": "Question",
        name: "What is the average lifespan of dental implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Most implants last over 10 years with 90% success rates. With good maintenance and regular check-ups, implants can function for 25 years or more.",
        },
      },
      {
        "@type": "Question",
        name: "How should I maintain and clean my full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Brush twice daily, floss, use antibacterial mouthwash, and visit the hygienist regularly. Water flossers are helpful for cleaning around implants.",
        },
      },
      {
        "@type": "Question",
        name: "Will I experience pain during or after the implant procedure?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The procedure is usually painless due to local anaesthetic. Mild discomfort or swelling after surgery is normal and can be managed with painkillers.",
        },
      },
      {
        "@type": "Question",
        name: "How soon can I eat normally after getting implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You can eat a few hours after surgery, but stick to soft foods and liquids for 24–48 hours to allow healing.",
        },
      },
      {
        "@type": "Question",
        name: "Will my speech be affected by full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Some temporary speech changes may occur, but most patients adjust quickly and often find their speech improves with full arch implants.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>Dental Implants in Ilkley, West Yorkshire | Regent Dental</title>
        <meta
          name="description"
          content="Replace missing teeth with natural-looking dental implants in West Yorkshire. Regent Dental provides long-lasting solutions to restore your smile and confidence."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/dental-implants"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <TransformYourSmile />
      <AfterCare />
      <QuestionsImplants />
      <CTA />
      <Contact heading={"Book your dental implant consultation"} />
      <Footer />
    </div>
  );
}

export default Index;
